import { type ReactNode, type SelectHTMLAttributes, type TextareaHTMLAttributes } from "react";

const BASE =
  "w-full rounded-md border bg-surface-2 px-4 py-2.5 text-sm text-text placeholder:text-muted focus:outline-none focus:ring-2 focus:ring-primary disabled:cursor-not-allowed disabled:opacity-70";

interface CampoSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  erro?: string;
  children: ReactNode;
}

/** Select no mesmo estilo do `Input` compartilhado (tokens semânticos, claro/escuro). */
export function CampoSelect({
  label,
  erro,
  id,
  className = "",
  children,
  ...props
}: CampoSelectProps) {
  const campoId = id ?? props.name;
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={campoId} className="text-sm font-medium tracking-wide text-text">
        {label}
      </label>
      <select
        id={campoId}
        className={`${BASE} ${erro ? "border-danger" : "border-transparent"} ${className}`}
        aria-invalid={!!erro}
        {...props}
      >
        {children}
      </select>
      {erro && <span className="text-xs text-danger">{erro}</span>}
    </div>
  );
}

interface CampoTextoProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  erro?: string;
  /** Mostra o contador "n/máx" (usa `maxLength`). */
  contador?: boolean;
}

export function CampoTexto({
  label,
  erro,
  id,
  className = "",
  contador = true,
  ...props
}: CampoTextoProps) {
  const campoId = id ?? props.name;
  const tamanho = typeof props.value === "string" ? props.value.length : 0;
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={campoId} className="text-sm font-medium tracking-wide text-text">
        {label}
      </label>
      <textarea
        id={campoId}
        rows={3}
        className={`${BASE} resize-y ${erro ? "border-danger" : "border-transparent"} ${className}`}
        aria-invalid={!!erro}
        {...props}
      />
      <div className="flex justify-between gap-2">
        {erro ? <span className="text-xs text-danger">{erro}</span> : <span />}
        {contador && props.maxLength ? (
          <span className="text-xs text-muted">
            {tamanho}/{props.maxLength}
          </span>
        ) : null}
      </div>
    </div>
  );
}
